import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { IntlService } from '@progress/kendo-angular-intl';
import { IReportFilterControl } from 'src/app/models';
import { Helpers } from 'src/app/helpers';
import { LocaleConfig } from 'ngx-daterangepicker-material';

@Component({
    selector: 'medpt-report-daterangepicker',
    templateUrl: './daterange.component.html',
    styleUrls: ['./daterange.component.scss'],
    standalone: false
})
export class DaterangeComponent implements OnInit {
  @Input() field!: IReportFilterControl;
  @Input() isMedPoint!: boolean;
  @Input() form!: FormGroup;
  @Output() filterChangeData = new EventEmitter<any>();  
  calendarLocale!: LocaleConfig;   
  
  constructor(public intl: IntlService) {
    this.calendarLocale = {
      applyLabel: 'Apply',
      clearLabel: 'Clear',
      format: 'DD-MMM-YYYY'      
    };
  }

  ngOnInit(): void {    
  }

  onDateChange(value: any) {
    if (Helpers.isNullOrUndefined(this.form.controls[this.field.controlName + "From"]))
      this.form.addControl(this.field.controlName + "From", new FormControl({ value: "", disabled: false }));    
    if (Helpers.isNullOrUndefined(this.form.controls[this.field.controlName + "To"]))
      this.form.addControl(this.field.controlName + "To", new FormControl({ value: "", disabled: false }));
    this.form.controls[this.field.controlName + "From"].setValue(value.startDate == null ? "" : value.startDate.format());
    this.form.controls[this.field.controlName + "To"].setValue(value.endDate == null ? "" : value.endDate.format());    
    this.filterChangeData.emit();
  }
}
